import React from "react";
import { I18nextProvider } from "react-i18next";
import { RouterProvider as Router } from "./common/Router";
import i18n from "../config/i18n";
import { MuiThemeProvider } from "@material-ui/core/styles";
import AppContent from "./LoginRoutes";
import { CssBaseline } from "@material-ui/core";
import "../assets/index.css";
import "typeface-noto-sans";
import theme from "../common/theme";

const App: React.FC = () => {
  return (
    <Router>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <I18nextProvider i18n={i18n}>
          <AppContent />
        </I18nextProvider>
      </MuiThemeProvider>
    </Router>
  );
};

export default App;
